import type { LucideIcon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card';

interface DeferredSectionProps {
  icon: LucideIcon;
  title: string;
  /** What is missing and when it arrives — never a count, never a zero. */
  explanation: string;
}

/**
 * A section whose data has no source yet. It says so in words instead of showing a value.
 *
 * The alternative — a silent `0` or `—` — is a lie the reader cannot detect: it reads as a
 * measured absence when the truth is that nobody has mapped the data.
 */
const DeferredSection = ({ icon: Icon, title, explanation }: DeferredSectionProps) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-base">
        <Icon className="h-4 w-4" aria-hidden="true" />
        {title}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="rounded-md border border-dashed border-zinc-200 p-4 text-sm text-zinc-500 dark:border-zinc-700 dark:text-zinc-400">
        {explanation}
      </p>
    </CardContent>
  </Card>
);

export default DeferredSection;
